function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
// Duplicated from ab-common
/* global toastr */
import _ from 'lodash';

/**
 * TODO: there is a duplicate of this in util/handleApiErrorResponse with slight differences.  We should consolidate these when possible
 */
export var handleApiErrorResponse = function handleApiErrorResponse(err) {
  if (err.status && err.status === 500) {
    toastr.error('Internal server error. Please try again later.');
    throw err;
  }
  var errorMessage = 'Something went wrong.';
  var errorMap = null;
  try {
    var body = err.body || err.response && err.response.data;
    if (body && body.errors) {
      if (Array.isArray(body.errors)) {
        errorMessage = body.errors.map(function (e) {
          if (e && e.detail) {
            return e.detail;
          } else if (e && e.message) {
            return e.message;
          } else if (e && e.code && e.title) {
            return '[' + e.code + '] ' + e.title;
          } else if (typeof e === 'string') {
            return e;
          }
          return '';
        }).join(', ');
        // return error map if errors has a meta key.
        errorMap = body.errors.reduce(function (arr, e) {
          if (arr) {
            if (!_.isEmpty(e.meta)) {
              return [].concat(_toConsumableArray(arr), [{
                field: e.meta.attribute,
                message: e.detail
              }]);
            } else {
              return null;
            }
          }
        }, []);
      } else if (typeof body.errors === 'string') {
        errorMessage = body.errors;
      }
    } else if (body && typeof body.error === 'string') {
      errorMessage = body.error;
    }
  } catch (internalError) {
    console.error('Error parsing error response:', internalError);
    console.error(err);
  }
  console.error(err);

  //  let UI/component handle error else show toastr message with all errors if errorMap does not exist, else
  if (errorMap && errorMap.length > 0) {
    return errorMap;
  } else {
    toastr.error(errorMessage);
    throw err;
  }
};
export var showErrors = function showErrors(error) {
  if (error && error.response && error.response.data && error.response.data.errors) {
    _.each(error.response.data.errors, function (error, key) {
      return toastr.error(key == null ? error : "".concat(key, ": ").concat(error));
    });
  } else if (error && error.response && error.response.data && error.response.data.message) {
    toastr.error(error.response.data.message);
  } else if (error && error.errors) {
    _.each(error.errors, function (error, key) {
      return toastr.error(key == null ? error : "".concat(key, ": ").concat(error));
    });
  } else if (error && error.message) {
    toastr.error(error.message);
  } else {
    toastr.error(error);
  }
};